export { default } from './QuestionAndAnswerItem';
